import MultiSelect from "../../ui/MultiSelect";
import React, { useCallback, useState, useEffect } from "react";
import {
  isAdminSupportOrFinance,
  isAgencyAdmin,
  isCompanyAdmin, isCompanyUser,
} from "../../modules/permissions";
import { agencyHasFeature, token } from "../../modules/auth";
import { fetchAgencies, fetchCompanies } from "../../redux/actions";
import { connect } from "react-redux";
import { AGENCY_PERMISSIONS, HOTEL_GROUP_TYPE_CODES } from "../../constants";

let PreferredProgrammeFilters = ({
  selectedAgency,
  setSelectedAgency,
  selectedCompany,
  setSelectedCompany,
  selectedGroup,
  setSelectedGroup,
  selectedBrand,
  setSelectedBrand,
  selectedVenue,
  setSelectedVenue,
  fetchAgencies,
  fetchCompanies,
  isAgencyAdmin,
  isAdminSupportOrFinance,
  token,
  hotelGroup,
  company,
  agency,
  isMyProgramme,
  isCompanyUser,
  showGroupFilters = false,
  isCompanyAdmin,
  labelPrefix = "Filter by",
  setSnapshotVenues,
  agencyHasCorporatePermission,
  agencyCanHaveChildAgencies,
  isDirect
}) => {
  const [agencies, setAgencies] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  // const [companyGroup, setCompanyGroup] = useState(null);
  // const [agencyGroup, setAgencyGroup] = useState(null);

  useEffect(() => {
    if (isAgencyAdmin || isAdminSupportOrFinance) {
      fetchAgencies(token, 1, { visibleOnly: true }, true).then(response => {
        setAgencies(response.data.data);
      });
      let companyParams = { visibleOnly: true, corporate: true };
      if (agency) {
        companyParams = {
          ...companyParams,
          agency: agency && agency.id ? agency.id : agency.value,
        };
      }
      fetchCompanies(token, 1, companyParams, true).then(response => {
        setCompanies(response.data.data);
      });
    }
  }, []);

  useEffect(() => {
    if (setSnapshotVenues) {
      let venues = getVenueOptions().map(option => option.value);

      // // When synthetic "direct venues" brand is selected, filter to only venues without a brand
      // if (selectedBrand?.isDirectVenues && hotelGroup?.venues) {
      //   const directVenueIds = hotelGroup.venues
      //     .filter(venue => !venue.hotel_brand)
      //     .map(venue => venue.id);
      //   venues = venues.filter(id => directVenueIds.includes(id));
      // }

      setSnapshotVenues(venues);
    }
  }, [hotelGroup, selectedCity, selectedBrand]);

  useEffect(() => {
    let queryParams = { visibleOnly: true, corporate: true };
    if (selectedAgency) {
      queryParams.agency = selectedAgency?.value || null
    }
    fetchCompanies(
      token,
      1,
      queryParams,
      true
    ).then(response => {
      setCompanies(response.data.data);
    });
  }, [selectedAgency]);

  useEffect(() => {
    if (selectedAgency === null && selectedCompany === null) {
      if (setSelectedGroup) setSelectedGroup(null);
      if (setSelectedBrand) setSelectedBrand(null);
      if (setSelectedVenue) setSelectedVenue(null);
    }
  }, [selectedAgency, selectedCompany, setSelectedGroup, setSelectedBrand, setSelectedVenue]);

  // useEffect(() => {
  //   if(selectedCompany) {
  //     console.log(selectedCompany)
  //     fetchHotelGroup(selectedCompany.preferredProgramme, token, true);
  //   }
  // }, [selectedCompany]);
  const getGroupOptions = () => {
    let options = [];
    if (hotelGroup && hotelGroup.groups && hotelGroup.groups.length > 0) {
      hotelGroup.groups
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(group => {
          options.push({
            text: group.name,
            value: group.id,
            label: group.name,
          });
        });
    }
    return options;
  };

  const getBrandOptions = () => {
    let options = [];
    // Check if hotelGroup (is a hotel group) and has venues without a brand (direct venues)
    const hasUnbrandedVenues = hotelGroup?.groupType?.code === HOTEL_GROUP_TYPE_CODES.HOTEL_GROUP && hotelGroup?.venues?.some(
      venue => !venue.hotel_brand
    );

    // Add synthetic option for direct venues if they exist
    if (hasUnbrandedVenues && hotelGroup?.name) {
      options.push({
        text: hotelGroup.name,
        value: `direct-${hotelGroup.id}`,
        label: hotelGroup.name,
        isDirectVenues: true,
      });
    }

    // Add actual brand options
    if (hotelGroup && hotelGroup.brands && hotelGroup.brands.length > 0) {
      hotelGroup.brands
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(group => {
          options.push({
            text: group.name,
            value: group.id,
            label: group.name,
          });
        });
    }
    return options;
  };

  const getChildrenOptions = () => {
    let options = [];
    // Add synthetic option for direct venues if the group has unbranded venues
    const hasUnbrandedVenues = hotelGroup?.groupType?.code === HOTEL_GROUP_TYPE_CODES.HOTEL_GROUP && (
      hotelGroup?.venues?.some(venue => !venue.hotel_brand) ||
      (!hotelGroup?.venues && hotelGroup?.venues_count > 0)
    );
    if (hasUnbrandedVenues && hotelGroup?.name) {
      options.push({
        text: hotelGroup.name,
        value: `direct-${hotelGroup.id}`,
        label: hotelGroup.name,
        isDirectVenues: true,
      });
    }
    if (hotelGroup && hotelGroup.children && hotelGroup.children.length > 0) {
      hotelGroup.children
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(group => {
          options.push({
            text: group.name,
            value: group.id,
            label: group.name,
          });
        });
    }
    return options;
  };

  const getVenueCityOptions = useCallback(() => {
    const options = [];
    const townsSet = new Set();
    if (hotelGroup?.venues?.length) {
      hotelGroup.venues.forEach(venue => {
        if (venue.town && venue.town.trim()) {
          townsSet.add(venue.town.trim());
        }
      });
    }

    if (hotelGroup?.children?.length) {
      hotelGroup.children.forEach(child => {
        if (child.venues?.length) {
          child.venues.forEach(venue => {
            if (venue.town?.trim()) townsSet.add(venue.town.trim());
          });
        }
      });
    }
    Array.from(townsSet)
      .sort((a, b) => a.localeCompare(b))
      .forEach(town => {
        options.push({
          text: town,
          value: town,
          label: town,
        });
      });

    return options;
  }, [hotelGroup]);

  const getVenueOptions = () => {
    let options = [];
    // console.log({hotelGroup})
    if (hotelGroup && hotelGroup.venues && hotelGroup.venues.length > 0) {
      hotelGroup.venues
        .filter(venue => {
          if (!selectedCity || selectedCity.length === 0) return true;

          return (
            venue.town &&
            selectedCity &&
            selectedCity.value === venue.town
          );
        })
        // .filter(v => console.log({v}))
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(group => {
          options.push({
            text: group.name,
            value: group.id,
            label: group.name,
          });
        });
    }
    return options;
  };

  const getAgencyOptions = () => {
    let options = [];
    if (agencies && agencies.length > 0) {
      agencies
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(agency => {
          options.push({
            text: agency.name,
            value: agency.id,
            label: agency.name,
            preferredProgramme: agency.preferred_programme_id,
          });
        });
    }
    return options;
  };

  const getCompanyOptions = () => {
    let options = [];
    // options.push({
    //   text: "No Value Selected",
    //   value: "",
    //   label: "No Value Selected",
    // });
    if (companies && companies.length > 0) {
      companies
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(company => {
          options.push({
            text: company.name,
            value: company.id,
            label: company.name,
            preferredProgramme: company.preferred_programme_id,
          });
        });
    }
    return options;
  };
  const handleAgencySelect = e => {
    // setAgencyGroup(hotelGroup);
    setSelectedAgency(e);
  };

  const handleCompanySelect = e => {
    if (!e || e.value === "") {
      setSelectedCompany(null);
      // setCompanyGroup(null);
    } else {
      // setCompanyGroup(hotelGroup);
      setSelectedCompany(e);
    }
  };

  const handleSelectGroup = e => {
    setSelectedGroup(e);
  };

  const handleSelectBrand = e => {
    setSelectedBrand(e);
  };

  const handleSelectVenue = e => {
    setSelectedVenue(e);
  };

  const handleSelectCity = e => {
    setSelectedCity(e);
  };

  return (
    // <div className="col">
    <div className={"flex"}>
      {agencyCanHaveChildAgencies && !isMyProgramme &&
      (!isCompanyAdmin && !isCompanyUser) &&
      (!hotelGroup
        // || hotelGroup.groupType.code === HOTEL_GROUP_TYPE_CODES.PREFERRED_PROGRAMME
      ) &&
      !agency ? (
        <div
          className={"mr-5"}
          style={{ width: "250px", textTransform: "capitalize" }}
        >
          <MultiSelect
            isClearable
            name="agency"
            label={labelPrefix + " Agency"}
            options={getAgencyOptions()}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            wrapperClassName="mb-0 w-full"
            onChange={e => handleAgencySelect(e)}
            value={selectedAgency}
            autoComplete={"off"}
            style={{
              searchBox: {
                "border-radius": "0px",
              },
            }}
          />
        </div>
      ) : null}
      {agencyHasCorporatePermission && !isMyProgramme &&
      !isCompanyAdmin &&
      (!hotelGroup || hotelGroup.groupType.code === HOTEL_GROUP_TYPE_CODES.PREFERRED_PROGRAMME) &&
      !company ? (
        <div
          className={"mr-5"}
          style={{ width: "250px", textTransform: "capitalize" }}
        >
          <MultiSelect
            isClearable
            name="agency"
            label={labelPrefix + " Company"}
            options={getCompanyOptions()}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            wrapperClassName="mb-0"
            onChange={e => handleCompanySelect(e)}
            value={selectedCompany}
            autoComplete={"off"}
            style={{
              searchBox: {
                "border-radius": "0px",
              },
            }}
          />
        </div>
      ) : null}
      {showGroupFilters &&
      hotelGroup.groupType.code === HOTEL_GROUP_TYPE_CODES.PREFERRED_PROGRAMME &&
      hotelGroup?.groups?.length > 0 ? (
        <div className={"mr-5"} style={{ width: "250px" }}>
          <MultiSelect
            isClearable
            name="agency"
            label={labelPrefix + " Hotel Group"}
            options={getGroupOptions()}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            wrapperClassName="mb-0"
            onChange={e => handleSelectGroup(e)}
            value={selectedGroup}
            autoComplete={"off"}
            style={{
              searchBox: {
                "border-radius": "0px",
              },
            }}
          />
        </div>
      ) : null}
      {showGroupFilters &&
      hotelGroup.groupType?.code !== HOTEL_GROUP_TYPE_CODES.HOTEL_BRAND && !isDirect && (
        (hotelGroup.brands && hotelGroup.brands.length > 0) ||
        hotelGroup?.venues?.some(venue => !venue.hotel_brand)
      ) ?
        <div className={"mr-5"} style={{ width: "250px" }}>
          <MultiSelect
            isClearable
            name="agency"
            label={labelPrefix + " Hotel Brands"}
            options={getBrandOptions()}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            wrapperClassName="mb-0"
            onChange={e => handleSelectBrand(e)}
            value={selectedBrand}
            autoComplete={"off"}
            style={{
              searchBox: {
                "border-radius": "0px",
              },
            }}
          />
      </div> : null}
      {showGroupFilters && !isDirect &&
      hotelGroup.children &&
      hotelGroup.children.length > 0 ? (
        <div className={"mr-5"} style={{ width: "250px" }}>
          <MultiSelect
            isClearable
            name="agency"
            label={labelPrefix + " Hotel Sub Group"}
            options={getChildrenOptions()}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            wrapperClassName="mb-0"
            onChange={e => handleSelectBrand(e)}
            value={selectedBrand}
            autoComplete={"off"}
            style={{
              searchBox: {
                "border-radius": "0px",
              },
            }}
          />
        </div>
      ) : null}
      {showGroupFilters && hotelGroup.venues && hotelGroup.venues.length > 0 ? (
        <div className={"mr-5"} style={{ width: "250px" }}>
          <MultiSelect
            isClearable
            name="venueCities"
            label={labelPrefix + " City"}
            options={getVenueCityOptions()}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            wrapperClassName="mb-0"
            onChange={e => handleSelectCity(e)}
            value={selectedCity}
            autoComplete={"off"}
            style={{
              searchBox: {
                "border-radius": "0px",
              },
            }}
          />
        </div>
      ) : null}
      {showGroupFilters && hotelGroup.venues && hotelGroup.venues.length > 0 ? (
        <div className={"mr-5"} style={{ width: "250px" }}>
          <MultiSelect
            isClearable
            name="venues"
            label={labelPrefix + " Venue"}
            options={getVenueOptions()}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            wrapperClassName="mb-0"
            onChange={e => handleSelectVenue(e)}
            value={selectedVenue}
            autoComplete={"off"}
            style={{
              searchBox: {
                "border-radius": "0px",
              },
            }}
          />
        </div>
      ) : null}
    </div>
    // </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    initialValues: props.hotelGroup,
    isCompanyAdmin: isCompanyAdmin(state.auth),
    isCompanyUser: isCompanyUser(state.auth),
    isAgencyAdmin: isAgencyAdmin(state.auth),
    isAdminSupportOrFinance: isAdminSupportOrFinance(state.auth),
    agencyHasCorporatePermission: agencyHasFeature(state.auth, AGENCY_PERMISSIONS.CAN_HAVE_CORPORATE_ACCOUNTS),
    agencyCanHaveChildAgencies: agencyHasFeature(state.auth, AGENCY_PERMISSIONS.CAN_ADD_CHILD_AGENCIES),
    token: token(state),
    ...state.countries,
  };
};

PreferredProgrammeFilters = connect(mapStateToProps, {
  fetchAgencies,
  fetchCompanies,
})(PreferredProgrammeFilters);

export default PreferredProgrammeFilters;
